import { BeButton, BeRow, BeSegmentedProgressBar, BeTooltip } from "@beos-css/react/index.ts";

export function TooltipDemo() {
	return (
		<section id="demo-tooltip">
			<h2>Tooltip / popover (BToolTip)</h2>
			<p>
				BeOS bubble help — R5 had none, so these arrived with Dano/R6. A black outline over a raised bevel and a pale-yellow fill, 6px below
				the target, flipping above when it would clip. The stylesheet does all of that.
			</p>

			<BeRow wrap gap="row">
				<BeTooltip tip="Empties the Trash for good.">
					<BeButton>Empty Trash</BeButton>
				</BeTooltip>

				<span data-be-tip="Pure CSS — no JavaScript." className="demo-tip-target">
					hover me (CSS only)
				</span>

				<BeTooltip
					sticky
					tip={
						<>
							<strong>Sticky popover.</strong> Move onto me — I stay open (BeOS <code>SetInline</code>).
						</>
					}
				>
					<BeButton>Hover for a popover</BeButton>
				</BeTooltip>

				<BeTooltip tip="Custom fill via --be-tooltip-bg." fillColor="var(--be-status-info)" textColor="#fff">
					<BeButton>Tinted tip</BeButton>
				</BeTooltip>
			</BeRow>

			<p>
				<strong>Per-segment tooltips.</strong> Pass <code>segmentTooltips</code> and every segment gets its own bubble, escaping the trough
				it sits in. Skip it when a <code>legend</code> already lists them.
			</p>
			<BeSegmentedProgressBar
				label="Epic progress"
				trailing="18 / 24"
				max={24}
				segmentTooltips
				segments={[
					{ value: 12, tone: "done", label: "Done" },
					{ value: 4, tone: "active", label: "Active" },
					{ value: 2, tone: "blocked", label: "Blocked" },
					{ value: 6, tone: "pending", label: "Pending" },
				]}
			/>
		</section>
	);
}
